import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const StatusOnHold = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.76709 10.625C6.42191 10.625 6.14209 10.3452 6.14209 10V6C6.14209 5.65482 6.42191 5.375 6.76709 5.375C7.11227 5.375 7.39209 5.65482 7.39209 6V10C7.39209 10.3452 7.11227 10.625 6.76709 10.625Z"
        fill="currentColor"
      />
      <path
        d="M8.60791 10C8.60791 10.3452 8.88773 10.625 9.23291 10.625C9.57809 10.625 9.85791 10.3452 9.85791 10V6C9.85791 5.65482 9.57809 5.375 9.23291 5.375C8.88773 5.375 8.60791 5.65482 8.60791 6V10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 12.75C10.6234 12.75 12.75 10.6234 12.75 8C12.75 5.37665 10.6234 3.25 8 3.25C5.37665 3.25 3.25 5.37665 3.25 8C3.25 10.6234 5.37665 12.75 8 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default StatusOnHold;
